/**
 * Canonical error codes for DHK8 HTTP contracts.
 *
 * SCREAMING_SNAKE_CASE. Each code maps 1:1 to an HTTP status by the helper
 * `errorCodeToStatus`. The list is intentionally small so clients can build
 * exhaustive switches.
 */
export const API_ERROR_CODES = [
    'UNAUTHENTICATED',
    'FORBIDDEN',
    'NOT_FOUND',
    'VALIDATION_ERROR',
    'CONFLICT',
    'DUPLICATE',
    'INVALID_STATE',
    'RATE_LIMITED',
    'UPSTREAM_ERROR',
    'INTERNAL_ERROR',
];
const STATUS_MAP = {
    VALIDATION_ERROR: 400,
    UNAUTHENTICATED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    DUPLICATE: 409,
    INVALID_STATE: 409,
    RATE_LIMITED: 429,
    INTERNAL_ERROR: 500,
    UPSTREAM_ERROR: 502,
};
export function errorCodeToStatus(code) {
    return STATUS_MAP[code] ?? 500;
}
//# sourceMappingURL=errors.js.map